import { render } from "./HeaderAndTextBlock.vue?vue&type=template&id=56782b58"
import script from "./HeaderAndTextBlock.vue?vue&type=script&lang=js"
export * from "./HeaderAndTextBlock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__